export default __webpack_public_path__ + "images/B8.ba7b495.png";